<template>
    <div class="single-message" :class="'level_'+level">
        <div class="message">
            <div :class="{'admin-header': (comment.comment && (comment.user.profilesId === 1 || comment.user.profilesId === 3))}">
                <span class="message-name-user">{{comment.user.name}}</span>

                <span class="message-date">{{date(comment.created)}}</span>

                <span class="message-time"></span>
                <span class="remove-button" @click="remove" v-if="editable && comment.comment">
                    <i class="ti-trash"></i>
                </span>
                <span class="remove-button" @click="pin" v-if="isAdmin"><i class="ti-pin"></i></span>
                <span class="remove-button" @click="toggleEditor" v-if="editable && comment.comment">
                    <i class="ti-pencil"></i>
                </span>
            </div>
            
            <p v-if="!showEditor" class="message-text" v-html="comment.comment"></p>
            <p v-else class="message-text">
                <Editor placeholder="Оставьте комментарий"
                        :content="comment.comment"
                        @change="setComment"
                        @ready="setComment"
                        @ctrl-enter="!hasErrorComment(commentText) && updateComment()"/>

                <div v-if="showEditor" style="height: 1em; margin: 1em 0">
                    <span v-if="hasSmallComment(commentText)">
                        <em>Сообщение должно быть как минимум 20 символов.</em>
                    </span>
                    <span v-if="hasNormalComment(commentText)">
                        <em>Длина сообщения {{ commentText.length }} из 4096 символов.</em>
                    </span>
                    <span class="error" v-if="hasLargeComment(commentText)">
                        <em>Слишком длинное сообщение. {{ commentText.length }} из 4096 символов.</em>
                    </span>
                </div>
                <button v-if="showEditor"
                        :disabled="hasErrorComment(commentText)"
                        class="reviews-button save-comment-button"
                        @click="updateComment">
                    Сохранить
                </button>
            </p>
            <p v-if="!comment.comment" style="color: gray"><em>Комментарий удален</em></p>

            <button class="message-button" @click="showReply = !showReply" v-if="isLogged">
                Ответить
            </button>
        </div>

        <div id="replyForm" v-show="showReply">
            <Editor placeholder="Оставьте комментарий"
                    :content="replyCommentHtml"
                    @change="setReplyComment"
                    @ctrl-enter="!hasErrorComment(replyCommentText) && saveReply"/>

            <div style="height: 1em; margin: 1em 0" class="small">
                <p v-show="hasSmallComment(replyCommentText)">
                    <em>Сообщение должно быть как минимум 20 символов.</em>
                </p>
                <p v-show="hasNormalComment(replyCommentText)">
                    <em>Длина сообщения {{ replyCommentText.length }} из 4096 символов.</em>
                </p>
                <p class="error" v-show="hasLargeComment(replyCommentText)">
                    <em>Слишком длинное сообщение. {{ replyCommentText.length }} из 4096 символов.</em>
                </p>
            </div>
            <button :disabled="hasErrorComment(replyCommentText)"
                    class="reviews-button small"
                    @click="saveReply">
                Отправить
            </button>
        </div>

        <div v-if="allComments[comment.id]" v-for="child in allComments[comment.id]">
            <Comment :comment="child" :level="level+1" />
        </div>
    </div>

</template>

<script>

    import Editor from './Editor';

    export default {
        name: 'Comment',
        components: {
            Editor
        },
        data() {
            return {
                showEditor: false,
                showReply: false,
                commentHtml: '',
                commentText: '',
                replyCommentHtml: '',
                replyCommentText: ''
            }
        },

        props: {
            comment: { required: true },
            level: { default: 0 }
        },

        computed: {

            allComments() {
                return this.$store.state.ideas.idea.commentList;
            },

            isAdmin() {
                return this.$store.getters['auth/isAdmin'];
            },

            isLogged() {
                return this.$store.getters['auth/isLogged'];
            },

            editable() {
                return this.isAdmin || this.isLogged && this.$store.state.auth.user.id === this.comment.user.id
            }
        },

        methods: {

            hasErrorComment (comment) {
                return this.hasSmallComment(comment) || this.hasLargeComment(comment)
            },

            hasSmallComment (comment) {
                return comment.length < 20
            },

            hasNormalComment (comment) {
                return comment.length >= 20 && comment.length <= 4096
            },

            hasLargeComment (comment) {
                return comment.length > 4096
            },

            toggleEditor() {
                if (!this.showEditor)
                    this.commentHtml = this.comment.comment;
                this.showEditor = !this.showEditor;
            },

            setComment ({ html, text }) {
                this.commentHtml = html;
                this.commentText = text;
            },

            setReplyComment ({ html, text }) {
                this.replyCommentHtml = html;
                this.replyCommentText = text;
            },

            updateComment () {
                this.showEditor = false;
                return this.$store.dispatch('ideas/updateComment', {
                    commentId: this.comment.id,
                    text: this.commentHtml
                }).then(() => this.$store.dispatch('ideas/loadIdea'))
            },

            saveReply () {
                this.$store.dispatch('ideas/saveComment', {
                    ideaId: this.comment.idea_id,
                    parentId: this.comment.id,
                    text: this.replyCommentHtml
                }).then((data) => {
                    this.replyCommentHtml = '';
                    this.showReply = false;
                    this.$store.dispatch('ideas/loadIdea')
                });
            },

            remove(){
                this.$confirm('Вы уверены, что хотите удалить комментарий?')
                    .$proxy(() => {
                        return this.$store.dispatch('ideas/deleteComment', { commentId: this.comment.id })
                            .then(() => this.$store.dispatch('ideas/loadIdea'))
                    })
            },

            pin() {
                this.$confirm('Вы уверены, что хотите установить этот комментарий в качестве официального ответа?')
                    .$proxy(() => {
                        return this.$store.dispatch('ideas/pinComment', {
                            ideaId: this.comment.idea_id,
                            commentId: this.comment.id
                        }).then(() => this.$store.dispatch('ideas/loadIdea'))
                    })
            }
        },

    }
</script>

<style>
    .remove-button {
        cursor: pointer;
        margin-left: 0.5em;
    }

    .save-comment-button{
        margin-top: 1em;
    }
</style>


// WEBPACK FOOTER //
// Comment.vue?41f5673f